module.exports = __webpack_public_path__ + "media/images/icons/submit_evidence_chevron-89bea29ec940274dc9ca1d1278bd1bb1.svg";